import classNames from "classnames/bind";
import { Spinner } from "common/components/Spinner";
import React from "react";
import styles from "./Button.module.css";

const classNameBuilder = classNames.bind(styles);

export interface Props {
  onClick?: () => void;
  className?: string;
  type?: "submit" | "reset" | "button";
  kind?: "primary" | "secondary" | "disabled" | "circular";
  loading?: boolean;
}

export const Button: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  className,
  kind = "primary",
  onClick = undefined,
  type,
  loading = false,
}) => {
  const classes = classNameBuilder(className, {
    button: true,
    primary: kind === "primary",
    secondary: kind === "secondary",
    disabled: kind === "disabled",
    circular: kind === "circular",
    loading: loading,
  });
  return (
    <button
      className={classes}
      onClick={onClick}
      disabled={kind === "disabled"}
      type={type ?? "button"}
    >
      {loading ? (
        <Spinner
          color={kind === "primary" ? "white" : "gray"}
          delay={0}
          size={25}
        />
      ) : (
        children
      )}
    </button>
  );
};
